module.exports = __webpack_public_path__ + "static/media/9.00a1a2da.jpg";